export const ADD_ARTICLE = 'ADD_ARTICLE';
export const INC_COUNTER = 'INC_COUNTER';
export const DEC_COUNTER = 'DEC_COUNTER';
export const DATA_LOADED = 'DATA_LOADED';

// register
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_SUCCSESS = 'REGISTER_SUCCSESS';
export const REGISTER_ERROR = 'REGISTER_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

// login
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCSESS = 'LOGIN_SUCCSESS';
export const LOGIN_ERROR = 'LOGLOGIN_ERRORIN';
export const CLEAR_LOGIN_DATA = 'CLEAR_LOGIN_DATA';

// modal login register
export const OPEN_MODAL_REGISTER = 'OPEN_MODAL_REGISTER';
export const CLOSE_MODAL_REGISTER = 'CLOSE_MODAL_REGISTER';
export const OPEN_MODAL_LOGIN = 'OPEN_MODAL_LOGIN';
export const CLOSE_MODAL_LOGIN = 'CLOSE_MODAL_LOGIN';

// modal add episode
export const OPEN_MODAL_ADD_EPISODE = 'OPEN_MODAL_ADD_EPISODE';
export const CLOSE_MODAL_ADD_EPISODE = 'CLOSE_MODAL_ADD_EPISODE';

// modal update episode
export const OPEN_MODAL_UPDATE_EPISODE = 'OPEN_MODAL_UPDATE_EPISODE';
export const CLOSE_MODAL_UPDATE_EPISODE = 'CLOSE_MODAL_UPDATE_EPISODE';

// get movie
export const GET_MOVIES_REQUEST = 'GET_MOVIES_REQUEST';
export const GET_MOVIES_SUCCSESS = 'GET_MOVIES_SUCCSESS';
export const GET_MOVIES_ERROR = 'GET_MOVIES_ERROR';

// delete movie
export const DELETE_MOVIE_REQUEST = 'DELETE_MOVIE_REQUEST';
export const DELETE_MOVIE_SUCCSESS = 'DELETE_MOVIE_SUCCSESS';
export const DELETE_MOVIE_ERROR = 'DELETE_MOVIE_ERROR';
export const CLEAR_DELETE_MOVIE_MESSAGE = 'CLEAR_DELETE_MOVIE_MESSAGE';
export const CLEAR_DELETE_MOVIE_ERROR = 'CLEAR_DELETE_MOVIE_ERROR';

// get tv
export const GET_TV_REQUEST = 'GET_TV_REQUEST';
export const GET_TV_SUCCSESS = 'GET_TV_SUCCSESS';
export const GET_TV_ERROR = 'GET_TV_ERROR';

// get detail movie
export const GET_DETAIL_MOVIE_REQUEST = 'GET_DETAIL_MOVIE_REQUEST';
export const GET_DETAIL_MOVIE_SUCCSESS = 'GET_DETAIL_MOVIE_SUCCSESS';
export const GET_DETAIL_MOVIE_ERROR = 'GET_DETAIL_MOVIE_ERROR';

// update movie
export const UPDATE_DETAIL_MOVIE_REQUEST = 'UPDATE_DETAIL_MOVIE_REQUEST';
export const UPDATE_DETAIL_MOVIE_SUCCESS = 'UPDATE_DETAIL_MOVIE_SUCCESS';
export const UPDATE_DETAIL_MOVIE_ERROR = 'UPDATE_DETAIL_MOVIE_ERROR';
export const CLEAR_UPDATE_DETAIL_MOVIE_MESSAGE = 'CLEAR_UPDATE_DETAIL_MOVIE_MESSAGE';
export const CLEAR_UPDATE_DETAIL_MOVIE_ERROR = 'CLEAR_UPDATE_DETAIL_MOVIE_ERROR';

// get episode
export const GET_EPISODE_BY_MOVIE_REQUEST = 'GET_EPISODE_BY_MOVIE_REQUEST';
export const GET_EPISODE_BY_MOVIE_SUCCSESS = 'GET_EPISODE_BY_MOVIE_SUCCSESS';
export const GET_EPISODE_BY_MOVIE_ERROR = 'GET_EPISODE_BY_MOVIE_ERROR';

// update episode
export const UPDATE_EPISODE_REQUEST = 'UPDATE_EPISODE_REQUEST';
export const UPDATE_EPISODE_SUCCESS = 'UPDATE_EPISODE_SUCCESS';
export const UPDATE_EPISODE_ERROR = 'UPDATE_EPISODE_ERROR';
export const CLEAR_UPDATE_EPISODE_MESSAGE = 'CLEAR_UPDATE_EPISODE_MESSAGE';
export const CLEAR_UPDATE_EPISODE_ERROR = 'CLEAR_UPDATE_EPISODE_ERROR';

// delete episode
export const DELETE_EPISODE_BY_MOVIE_REQUEST = 'DELETE_EPISODE_BY_MOVIE_REQUEST';
export const DELETE_EPISODE_BY_MOVIE_SUCCESS = 'DELETE_EPISODE_BY_MOVIE_SUCCESS';
export const DELETE_EPISODE_BY_MOVIE_ERROR = 'DELETE_EPISODE_BY_MOVIE_ERROR';
export const CLEAR_DELETE_EPISODE_BY_MOVIE_MESSAGE = 'CLEAR_DELETE_EPISODE_BY_MOVIE_MESSAGE';
export const CLEAR_DELETE_EPISODE_BY_MOVIE_ERROR = 'CLEAR_DELETE_EPISODE_BY_MOVIE_ERROR';

// autentikasi
export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_SUCCSESS = 'AUTH_SUCCSESS';
export const AUTH_ERROR = 'AUTH_ERROR';

// logout
export const LOGOUT_USER = 'LOGOUT_USER';

// post upgrade
export const UPGRADE_REQUEST = 'UPGRADE_REQUEST';
export const UPGRADE_SUCCSESS = 'UPGRADE_SUCCSESS';
export const UPGRADE_ERROR = 'UPGRADE_ERROR';
export const CLEAR_UPGRADE_MESSAGE = 'CLEAR_UPGRADE_MESSAGE';
export const CLEAR_UPGRADE_ERROR = 'CLEAR_UPGRADE_ERROR';

// get transaction
export const TRANS_REQUEST = 'TRANS_REQUEST';
export const TRANS_SUCCSESS = 'TRANS_SUCCSESS';
export const TRANS_ERROR = 'TRANS_ERROR';

// update transaction status
export const TRANS_UPDATE_REQUEST = 'TRANS_UPDATE_REQUEST';
export const TRANS_UPDATE_SUCCSESS = 'TRANS_UPDATE_SUCCSESS';
export const TRANS_UPDATE_ERROR = 'TRANS_UPDATE_ERROR';

// post episode
export const ADD_EPISODE_REQUEST = 'ADD_EPISODE_REQUEST';
export const ADD_EPISODE_SUCCSESS = 'ADD_EPISODE_SUCCSESS';
export const ADD_EPISODE_ERROR = 'ADD_EPISODE_SUCCSESS';

// get categories
export const GET_CATEGORIES_REQUEST = 'GET_CATEGORIES_REQUEST';
export const GET_CATEGORIES_SUCCSESS = 'GET_CATEGORIES_SUCCSESS';
export const GET_CATEGORIES_ERROR = 'GET_CATEGORIES_ERROR';

// post movie
export const ADD_MOVIE_REQUEST = 'ADD_MOVIE_REQUEST';
export const ADD_MOVIE_SUCCSESS = 'ADD_MOVIE_SUCCSESS';
export const ADD_MOVIE_ERROR = 'ADD_MOVIE_ERROR';
export const CLEAR_ADD_MOVIE_MESSAGE = 'CLEAR_ADD_MOVIE_MESSAGE';
export const CLEAR_ADD_MOVIE_ERROR = 'CLEAR_ADD_MOVIE_ERROR';

// post episodes
export const ADD_EPISODES_REQUEST = 'ADD_EPISODES_REQUEST';
export const ADD_EPISODES_SUCCSESS = 'ADD_EPISODES_SUCCSESS';
export const ADD_EPISODES_ERROR = 'ADD_EPISODES_ERROR';
export const CLEAR_ADD_EPISODES_MESSAGE = 'CLEAR_ADD_EPISODES_MESSAGE';
export const CLEAR_ADD_EPISODES_ERROR = 'CLEAR_ADD_EPISODES_ERROR';
